import React from 'react';
import PieChart from './PieChart';

const AttendanceStatusChart = ({ data = [], statusTypes = [] }) => {
  const statusCounts = data.reduce((acc, item) => {
    const status = item.lifecycleStatus || 'Sem Status';
    acc[status] = (acc[status] || 0) + 1;
    return acc;
  }, {});

  const chartData = Object.keys(statusCounts).map(key => ({
    name: key,
    value: statusCounts[key]
  }));

  // Criar mapa de cores baseado nos statusTypes
  const statusColorMap = {};
  
  // Adicionar cores dos status personalizados
  statusTypes.forEach(statusType => {
    if (statusType.type === 'atendimento' && statusType.color) {
      statusColorMap[statusType.name] = statusType.color;
    }
  });
  
  // Adicionar cores padrão para status fixos
  const defaultColors = {
    'Aberto': '#38bdf8',
    'Concluído': '#22c55e',
    'Sem Status': '#6b7280'
  };
  
  // Combinar cores padrão com personalizadas (personalizadas têm prioridade)
  const colorMap = { ...defaultColors, ...statusColorMap };
  
  // Gerar array de cores na ordem dos dados do gráfico
  const COLORS = chartData.map(item => colorMap[item.name] || '#6b7280');

  return (
    <div className="h-full flex flex-col">
      <div className="flex justify-between items-center mb-1 px-1">
        <h3 className="text-white font-semibold text-sm opacity-0">.</h3>
        <span className="text-xs text-gray-400 bg-white/5 px-2 py-0.5 rounded">Período: Total</span>
      </div>
      <div className="flex-1">
        <PieChart 
          data={chartData} 
          title="Status das Implantações" 
          colors={COLORS} 
        />
      </div>
    </div>
  );
};

export default AttendanceStatusChart;